import { useMutation } from '@tanstack/react-query';

import { agent } from 'api/agent';

interface Props {
  code: string;
}

const sendTwofaCodeMutation = () => useMutation({
  mutationKey: ['sendTwofaCode'],
  mutationFn: (body: Props) => agent.getClient(false).post('/twofa/authenticate', body),
});

export default sendTwofaCodeMutation;
